import {
  applyOverrides,
  salesPriceCard as baseSalesPriceCard,
} from '../../shared';

export const salesPriceCard = applyOverrides(baseSalesPriceCard, {
  layout: [[{ name: 'offerPrice', size: 100 }]],
  fields: {
    salesPrice: {
      name: 'offerPrice',
      label: 'Current Sales Price',
      validation: [
        {
          type: 'required',
          message: 'Required',
        },
      ],
    },
  },
});
